import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';

const ProductWatchDogsQuery = gql`
    query($productId: String!) {
        getAwaitingCustomers(productId: $productId) {
            email
            customer {
                invoiceFirstName
                invoiceLastName
                invoiceCountry
                email
            }
        }
    }
`;

interface IInputProps {
    children?: any;
    productId?: string;
}

interface Response {
    data: any;
}

class GetProductWatchDogsQuery extends React.Component<ChildProps<IInputProps, Response>, {}> {
    render() {
        const { productWatchDogs }: any = this.props;
        return this.props.children({
            productWatchDogs,
        });
    }
}

export default compose(
    graphql<IInputProps, Response>(ProductWatchDogsQuery, {
        name: 'productWatchDogs',
        options: props => ({
            variables: {
                productId: props.productId
            },
            fetchPolicy: 'network-only'
        })
    }),
)(GetProductWatchDogsQuery);



// WEBPACK FOOTER //
// ./src/components/Query/WatchDogs/AvaitingCustomers.tsx